import { Component } from '@angular/core';
import { RoutingStateService } from './shared/services/routing-state.service';
import { VersionCheckService } from './shared/services/version-check.service';
import { environment } from '../environments/environment.prod';
import { Menu } from './menu/menu';
import { AlertComponent } from './shared/alert/alert.component';

@Component({
  selector: 'app-root',
  imports: [Menu, AlertComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected title = 'espace_client_ng';
  constructor(routingState: RoutingStateService, versionCheckService: VersionCheckService) {
    routingState.loadRouting();
    versionCheckService.initVersionCheck(window.location.origin + '/version.json', 1000 * 60 * 30);
  }
}
